<template>
  <img
    :class="'c-img ' + additionalClass"
    :src="src"
    @error="replaceByFallback($event)"
  >
</template>

<script>
/**
 * Komponente zur Darstellung von Bildern inklusive einer Funktion zur Darstellung von Fallback-Bildern
 * @displayName BaseImage
 */
export default {
  name: 'BaseImage',
  props: {
    /**
     * Bild URL
     */
    src: {
      type: String,
      required: true
    },
    /**
     * CSS Klassen
     */
    additionalClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      fallbackInUse: false
    }
  },
  methods: {
    replaceByFallback(e) {
      if (!this.fallbackInUse) {
        this.fallbackInUse = true;
        e.target.src = this.$store.state.rootUrl + 'build/pix/no_image.png';
      }
    }
  }
}
</script>

<style lang="less">
  .c-img {
    max-width: 100%;
    height: auto;
  }
</style>
